import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'

import {
    changeStatus,
    limpa_msgs
} from '../../actions'
class ModalStatus extends Component {

    constructor(props) {
        super(props)

        this.state = {
            frase : '',
            small: '',
            img: 'cancelado.png',
            click: 0
        }

        this.closeModal = this.closeModal.bind(this)
    }

    componentWillMount(){
       // this.frase(this.props.status)
    }

    frase (status) {
        var frase = '',small = '',img = '',buttonText = ''

        switch(status) {
            case 'finalizado':
                frase = 'Gostaria de finalizar o documento em processo?'
                small = ''
                img = 'concluido.png'
                buttonText = 'Finalizar'
            break;
            case 'cancelado':
                frase = 'Gostaria de cancelar o documento em processo?'
                small = 'As assinaturas já efetuadas serão invalidadas'
                img = 'cancelado.png'
                buttonText = 'Cancelar'
            break;
        }

        return { frase, small, img, buttonText }
        // this.setState({frase,small,img})
    }

    closeModal(){
        this.props.closeModal()
    }

    action(){
        const { documento } = this.props.documentos
        this.props.changeStatus(documento.id, this.props.status, documento.dataLimite , err => {
            const { change_status_msg } = this.props.documentos

            if(err) toast.error(change_status_msg)
            else toast.success(change_status_msg)

            document.querySelector('#modalStatus .close').click()
            this.closeModal()
        })
    }


    render() {
        var { frase, small, img, buttonText } = this.frase(this.props.status)
        var { load_change_status, change_status_msg, change_status_error } = this.props.documentos

        return (
            <div className="modal fade" id="modalStatus" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{this.props.status == 'finalizado' ? 'Finalizar' : 'Cancelar'} documento</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            <img className="mb-4 " src={`/assets/imagem/${img}`} alt="" width="100" height="100" />
        
                            <h4>{frase}</h4>
                            <small>{small}</small>
                        </div>

                        {change_status_msg != ''
                            ?<div className={`alert alert-${change_status_error?'danger':'success'}`} role="alert" style={customStyles.alert}>
                                {change_status_msg}
                            </div>
                            :null
                        }

                        <div className="modal-footer">
                            {load_change_status
                                ?<div className="spinner-border" role="status" style={{margin:'5%'}}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                                :<button type="button" className="btn btn-primary" onClick={() => this.action()}>{buttonText}</button>
                            }
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={ () => this.props.limpa_msgs()}>Fechar</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const customStyles = {
    modal: {
        width:'50%',
        zIndex:'99999'
    },
    modalDialog: {
        margin: 0,
        padding: 0,
        maxWidth:'100%',
        width:'100%',
        height:'100%'
    },
    contentModal: {
        border: 0
    },
    alert: {
        padding: '1%',
        marginLeft: '5%',
        marginRight: '5%',
        textAlign: 'center'
    }
}

const mapStateToProps = ({ documentos, auth }) => {
    return {
        auth,
        documentos,
    }
}
export default connect(mapStateToProps, {
    changeStatus,
    limpa_msgs
})(ModalStatus);